import { Divider, Table } from "antd";
import React from "react";
import { useGetApplicationHistoryQuery } from "../../../../store/api/applicationBankApi/applicationBank.api";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { ColumnsType } from "antd/es/table";

type ApplicationHistoryTableRow = {
  application_action: string;
  user: string;
  date: string;
  time: string;
};

const columns: ColumnsType<ApplicationHistoryTableRow> = [
  {
    title: "Дата",
    dataIndex: "date",
    key: "date",
    width: "100px",
  },
  {
    title: "Время",
    dataIndex: "time",
    key: "time",
    width: "100px",
  },
  {
    title: "Действие по заявке",
    dataIndex: "application_action",
    key: "application_action",
    width: "50%",
  },
  {
    title: "Кто внес изменения",
    dataIndex: "user",
    key: "user",
    width: "auto",
  },
];

export const ApplicationHistory = () => {
  const { applicationBankId } = useParams();

  const { data } = useGetApplicationHistoryQuery(Number(applicationBankId), {
    refetchOnMountOrArgChange: true,
  });
  const dataSource = data?.map((log) => {
    return {
      application_action: log.text,
      user: log.user,
      date: dayjs(log.created_at).format("DD.MM.YYYY"),
      time: dayjs(log.created_at).format("HH:mm:ss"),
    };
  });

  return (
    <section>
      <Divider orientation="left">История изменений</Divider>

      <Table
        scroll={{ scrollToFirstRowOnChange: true }}
        dataSource={dataSource}
        columns={columns}
      ></Table>
    </section>
  );
};
